export default "__VITE_ASSET__DbWCSUwo__"